import * as React from 'react';
import { useState } from 'react';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import Stack from '@mui/material/Stack';
import { Box } from '@mui/system';
import FormHelperText from '@mui/material/FormHelperText';
import LoadingSpinner from '../../support/LoadingSpinner';
import toast from 'react-hot-toast';
import axios from '../../../services/ApiService';

export function UpdatePassword(): React.JSX.Element {
  const [loading, setLoading] = useState(false);
  const [passwords, setPasswords] = useState({
    newPassword: '',
    confirmPassword: ''
  });
  const [errors, setErrors] = useState({
    newPassword: '',
    confirmPassword: ''
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPasswords({
      ...passwords,
      [event.target.name]: event.target.value
    });
    setErrors({
      newPassword: '',
      confirmPassword: ''
    });
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const newErrors = {
      newPassword: '',
      confirmPassword: ''
    };

    if (passwords.newPassword.length < 6) {
      newErrors.newPassword = 'Password must be at least 6 characters';
    }
    if (passwords.newPassword !== passwords.confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
    }

    if (newErrors.newPassword || newErrors.confirmPassword) {
      setErrors(newErrors);
      return;
    }
    
    const cred = {
      userId: '',
      password: passwords.newPassword,
    };
    setLoading(true);
    try {
      const response = await axios.post("/updatePassword", cred);
      toast.success("Password Updated Successfully!");  
      setPasswords({
        newPassword: '',
        confirmPassword: ''
      });
    } catch (error) {
        console.error('Error updating password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Card>
        <CardHeader subheader="Update password" title="Password" />
        <Divider />
        <CardContent>
          <Box sx={{ maxWidth: '800px' }}>
            <Stack spacing={3} sx={{ maxWidth: 'flex' }}>
              <FormControl fullWidth error={!!errors.newPassword}>
                <InputLabel>New Password</InputLabel>
                <OutlinedInput 
                  label="New Password" 
                  name="newPassword"
                  type="password"
                  value={passwords.newPassword}
                  onChange={handleChange}
                />
                {errors.newPassword && <FormHelperText>{errors.newPassword}</FormHelperText>}
              </FormControl>
              <FormControl fullWidth error={!!errors.confirmPassword}>
                <InputLabel>Confirm Password</InputLabel>
                <OutlinedInput 
                  label="Confirm password" 
                  name="confirmPassword"
                  type="password"
                  value={passwords.confirmPassword}
                  onChange={handleChange}
                />
                {errors.confirmPassword && <FormHelperText>{errors.confirmPassword}</FormHelperText>}
              </FormControl>
            </Stack>
          </Box>
        </CardContent>
        <Divider />
        <CardActions sx={{ justifyContent: 'flex-end' }}>
          <Button variant="contained" type="submit">Update</Button>
        </CardActions>
      </Card>
      <LoadingSpinner loading={loading} />
    </form>
  );
}
